import tw from 'twin.macro';
import {
  styled
} from 'styled-components';

export const InviteEmailText = styled.span<{ $isGrey?: boolean }>`
  ${tw`text-15-20 font-medium text-button-blue`}
`;
